import { get } from 'helpers/apiHelpers';
import types from 'helpers/constants';

export const fetchSexes = () => async dispatch => {
  dispatch({
    type: types.FETCH_SEXES,
  });

  try {
    const { 'hydra:member': sexes } = await get('/sexes', {
      pagination: false,
    });

    dispatch({
      type: types.FETCH_SEXES_SUCCESS,
      payload: {
        sexes,
      },
    });
    // eslint-disable-next-line @typescript-eslint/no-unused-vars -- FIXME
  } catch (error) {
    dispatch({
      type: types.FETCH_SEXES_FAILED,
    });
  }
};

export const fetchHowKnow = () => async dispatch => {
  dispatch({
    type: types.FETCH_HOW_KNOW,
  });

  try {
    const { 'hydra:member': howKnow } = await get('/how-knows', {
      pagination: false,
    });

    dispatch({
      type: types.FETCH_HOW_KNOW_SUCCESS,
      payload: {
        howKnow,
      },
    });
    // eslint-disable-next-line @typescript-eslint/no-unused-vars -- FIXME
  } catch (error) {
    dispatch({
      type: types.FETCH_HOW_KNOW_FAILED,
    });
  }
};

export const fetchProductionTags = () => async dispatch => {
  dispatch({
    type: types.FETCH_PRODUCTION_TAGS,
  });

  try {
    const { 'hydra:member': productionTags } = await get('/tags', {
      pagination: false,
    });

    dispatch({
      type: types.FETCH_PRODUCTION_TAGS_SUCCESS,
      payload: {
        productionTags,
      },
    });
    // eslint-disable-next-line @typescript-eslint/no-unused-vars -- FIXME
  } catch (error) {
    dispatch({
      type: types.FETCH_PRODUCTION_TAGS_FAILED,
    });
  }
};

export const fetchSmsTagsForClients = () => async dispatch => {
  dispatch({
    type: types.FETCH_SMS_TAGS,
  });

  try {
    const { 'hydra:member': smsClientTags } = await get('/sms-client-tags', {
      pagination: false,
    });

    dispatch({
      type: types.FETCH_SMS_TAGS_SUCCESS,
      payload: {
        smsClientTags,
      },
    });
    // eslint-disable-next-line @typescript-eslint/no-unused-vars -- FIXME
  } catch (error) {
    dispatch({
      type: types.FETCH_SMS_TAGS_FAILED,
    });
  }
};
